module.exports = __webpack_public_path__ + "img/cs-3.bde96db4.jpg";